import Provider from '@/classes/v2/Provider';

export default class SmsNumber {
  constructor({ active, number, password, product, sessionKey, stopRequests, providerId }) {
    this.active = active || false;
    this.number = number || null;
    this.password = password || null;
    this.product = product || null;
    this.sessionKey = sessionKey || null;
    this.stopRequests = stopRequests || [];
    this.providerId = providerId;
    this.provider = new Provider({ providerId });
  }

  get blockedNumbersList() {
    return this.stopRequests?.map(req => req.fromNumber);
  }

  get activeBlockedNumbersList() {
    return this.stopRequests?.filter(req => {
      return req.stopDate > req.restartDate;
    }).map(num => num.fromNumber);
  }

  isBlocked(number) {
    if (number) {
      return this.activeBlockedNumbersList.includes(number);
    }
  }
}
